"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import cs from "classnames";
import { setCookie } from "@/utils/setCookie";
import Box from "@sendsprint/ui-react/components/box";
import Typography from "@sendsprint/ui-react/components/typography";
import Container from "@sendsprint/ui-react/components/container";
import Button from "@sendsprint/ui-react/components/button";
import { COOKIE_CONSENT_KEY } from "@/hooks/utils/useCookieConsent";

interface Props {
  handleAcceptConsent: () => void;
}

const CookieConsentNoticeInner = ({ handleAcceptConsent }: Props) => {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowConsent(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  const handleSetCookie = () => {
    if (handleAcceptConsent) {
      handleAcceptConsent();
    }
    setCookie(COOKIE_CONSENT_KEY, "true");
    setShowConsent(false);
  };

  return (
    <Box
      className={cs(
        "ss:w-full ss:shadow-lg ss:border ss:border-neutral-200 ss:py-7 ss:duration-150 ss:fixed ss:bottom-0 ss:z-214748300374 ss:bg-white ss:rounded-t-2xl",
        {
          "ss:opacity-100": showConsent,
          "ss:opacity-0 ss:hidden": !showConsent,
        },
      )}
    >
      <Container className="ss:flex ss:flex-wrap ss:gap-10 ss:items-center ss:justify-between">
        <Typography variant="paragraphLarge">
          We use cookies to enhance user experience.
          <Link
            className="ss:cursor-pointer"
            style={{
              color: "#05214c",
              marginLeft: "10px",
              fontWeight: "bold",
              textDecoration: "underline",
            }}
            href="/cookies-policy"
          >
            <span className="ss:sr-only">Go to cookie policy page</span>
            Learn More
          </Link>
        </Typography>
        <Button
          onClick={handleSetCookie}
          className="ss:px-16"
          label="I agree"
        />
      </Container>
    </Box>
  );
};

export default CookieConsentNoticeInner;
